


// CheckPageTitle.js
import React, { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setActiveModal } from "../../Sidebar/SideBarSlice";

const CheckPageTitle = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  // Define a mapping of paths to headings, excluding role prefix
  const pathToTitleMap = {
    "/dashboard": "Dashboard",
    "/provider/listing": "Doctors",
    "/patient/list": "Patients",
    "/patient": "Patient Details",
    "/provider/create": "Create Doctor",
    "/provider/profile": "Profile Details",
    "/profile": "Profile Details",
    "/update/password": "Change Password",
    "/provider/edit": "Edit Doctor",
    "/patient/treatmentList": "Medication Listing",
    "/patient/adheranceList": "Adherance Listing",
    "/patient/notes": "Notes",
    "/patient/view-note": "View Notes",
    "/media-management": "Media Management",
    "/media-management/add-media": "Media Management",
    "/media-management/view-media": "View Management",
    "/survey/survey-list": "Survey Management",
    "/survey/question-list": "Survey Management",
    "/patient/response-survey-list": "Survey List",
    "/patient/response-list": "Patient Response",
    "/forum": "Forum",
    "/community": "Forum",
    "/analytics": "Analytics",
    "/feedback": "Feedback",
    "/chat": "Chat With Patient",
    "/template-manager": "Template Manager",
    "/policies": "Policies",
    "/education-management": "Education Management",
  };

  useLayoutEffect(() => {
    const currentPath = location.pathname;

    // Remove role prefix (e.g., /admin or /doctor)
    const parts = currentPath.split("/").filter(Boolean); // removes empty strings
    const normalizedPath = parts.length > 1 ? `/${parts.slice(1).join("/")}` : `/${parts[0]}`;
    const title = pathToTitleMap[normalizedPath] || "Page Not Found";
    dispatch(setActiveModal(title));
  }, [location, dispatch]);

  return null;
};

export default CheckPageTitle;
